<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter"><strong>Contents</strong></h1>
<p class="toc1"><a class="hlink" href="#/OEBPS/int.htm">Introduction: Your Budget Will Help You Get What You Want</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/p01.htm">Part I: Getting Started</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c01.htm">Chapter 1: What Do You Need to Create a Budget?</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c02.htm">Chapter 2: Setting Your Goals</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c03.htm">Chapter 3: What Do You Have?</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c04.htm">Chapter 4: What Are You Spending?</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c05.htm">Chapter 5: What Do You Owe?</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c06.htm">Chapter 6: Okay—You’re Ready to Create a Budget</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/p02.htm">Part II: Sticking to Your Budget</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c07.htm">Chapter 7: Saving Around the Household</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c08.htm">Chapter 8: Saving on Transportation</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c09.htm">Chapter 9: Watching What You Spend</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/p03.htm">Part III: Expanding and Adjusting Your Budget</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c10.htm">Chapter 10: Paying Down Debt</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c11.htm">Chapter 11: Saving and Investing</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c12.htm">Chapter 12: Merging Your Finances</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c13.htm">Chapter 13: Baby on the Way</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c14.htm">Chapter 14: Your Biggest Purchase</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c15.htm">Chapter 15: Finding Money in Your House</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c16.htm">Chapter 16: Saving for Vacations and Holidays</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c17.htm">Chapter 17: Saving for College</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c18.htm">Chapter 18: Saving for Retirement</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c19.htm">Chapter 19: How to Survive Unemployment</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/c20.htm">Chapter 20: Sticking to Your Budget—No Matter What</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/conc.htm">Conclusion: Living the Life You Want</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/appa.htm">Appendix A: Debt-Restructuring Resources</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/appb.htm">Appendix B: Budgeting Websites and Online Tools</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?00294d9d